import React, { useEffect, useRef } from 'react'
import { Platform } from 'react-native'

import KeyBoardWrapper from '@zet/common/components/keyboardWrapper'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Alert } from '@zet/design-system/alert'
import { Button } from '@zet/design-system/button'
import { InputGroup } from '@zet/design-system/input'
import { Stack } from '@zet/design-system/layout'
import { B2, H4, SH2 } from '@zet/design-system/typography'
import { PLACE_HOLDER_PHONE_NUMBER } from '@zet/utils/Constants'
import Lottie from 'lottie-react'
import LottieView from 'lottie-react-native'
import { Controller, useForm } from 'react-hook-form'

import { useVerifyPhoneNumberBridge } from '../../../api/login/hooks'
import { i18n } from '../../../localization'
import { MOBILE_NUMBER_REGEX } from '../../../utils/regularExpression'
import {
  MOBILE_NUMBER_EMPTY,
  MOBILE_NUMBER_VALIDATION,
} from '../../../utils/validationMessage'

const VerifyPhoneNumber = () => {
  const isWeb = Platform.OS === 'web'
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
    getValues,
    setError,
    clearErrors,
  } = useForm({
    mode: 'onBlur',
  })
  const navigation = useNavigation()

  const inputRef = useRef(null)
  const { mutate, isLoading, isSuccess, data } = useVerifyPhoneNumberBridge()

  const onSubmit = () => {
    mutate({ phoneNumber: getValues('phoneNumber') })
  }

  useEffect(() => {
    if (isSuccess) {
      if (data?.error === null) {
        navigation.navigate('VerifyOtp', {
          phoneNumber: getValues('phoneNumber') || '',
        })
      } else if (data?.error) {
        setError('phoneNumber', { message: data?.error })
      }
    }
  }, [isSuccess])

  const onPressTermsOfUse = () => {
    navigation.navigate('TermsOfUse', {
      isCustomerFlow: false,
    })
  }

  const onPressPrivacyPolicy = () => {
    navigation.navigate('PrivacyPolicy', {
      isCustomerFlow: false,
    })
  }

  return (
    <KeyBoardWrapper
      className=" mb-3  flex-1 bg-white px-3"
      BottomSheet={
        <>
          <Stack>
            {errors?.phoneNumber?.message && (
              <Alert intent={'error'}>{errors?.phoneNumber?.message}</Alert>
            )}
          </Stack>
          <B2>
            {i18n.t('verifyPhNum.agree')}
            <SH2 className="text-primary-200" onPress={onPressTermsOfUse}>
              {' '}
              {i18n.t('verifyPhNum.terms')}
            </SH2>
            <B2> {i18n.t('verifyPhNum.and')} </B2>
            <SH2 className="text-primary-200" onPress={onPressPrivacyPolicy}>
              {i18n.t('verifyPhNum.privacyPolicy')}
            </SH2>
          </B2>
          <Button
            className="mt-3"
            fullWidth
            size="lg"
            onPress={handleSubmit(onSubmit)}
            loading={isLoading}
            disabled={!isValid}
          >
            {i18n.t('verifyPhNum.continue')}
          </Button>
        </>
      }
    >
      <Stack>
        <Stack className="mt-7 items-center justify-center">
          <Stack className={`${isWeb && 'h-14 w-14'}`}>
             {isWeb ? <Lottie animationData={require('../../../../assets/lottie/SMSVerification.json')} /> : 
            <LottieView
              autoPlay
              className="h-[108] w-[108] self-center"
              source={require('../../../../assets/lottie/SMSVerification.json')}
            /> }
          </Stack>

          <H4 className="mt-[28]  text-center ">
            {i18n.t('verifyPhNum.verify')}
          </H4>
        </Stack>
        <Stack className="mt-10 pt-4">
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <InputGroup
                placeholder={PLACE_HOLDER_PHONE_NUMBER}
                onBlur={onBlur}
                onChangeText={(value) => {
                  clearErrors('phoneNumber')
                  onChange(value)
                  if (value.length === 10) {
                    inputRef?.current?.blur()
                  }
                }}
                maxLength={10}
                value={value}
                type={'primary'}
                size="md"
                keyboardType="number-pad"
                ref={inputRef}
                className="h-[100%]"
              />
            )}
            name="phoneNumber"
            rules={{
              required: {
                value: true,
                message: MOBILE_NUMBER_EMPTY,
              },
              pattern: {
                value: MOBILE_NUMBER_REGEX,
                message: MOBILE_NUMBER_VALIDATION,
              },
            }}
          />
        </Stack>
      </Stack>
    </KeyBoardWrapper>
  )
}

export default VerifyPhoneNumber
